import React, { useEffect, useState } from 'react'
import Footer from '../components/common/Footer'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { apiConnector } from '../services/apiconnector'
import { categories } from '../services/apis'
import { getCatalogPageData } from '../services/operations/pageAndComponentData'
import Error from './Error'
import CourseCard from '../components/core/Catalog/Course_Card'
import CourseSlider from '../components/core/Catalog/CourseSlider'

const Catalog = () => {

    const { loading } = useSelector((state) => state.profile)
    const { catalogName } = useParams() //extract from the link
    const [active, setActive] = useState(1)
    const [catalogPageData, setCatalogPageData] = useState(null);
    const [categoryId, setCategoryId] = useState("");
    const [notFound, setNotFound] = useState(false);

    //Fetch all categories
    useEffect(()=> {
        const getCategories = async() => {
            const res = await apiConnector("GET", categories.CATEGORIES_API);

            //A catalog name in the url that matches no category used to throw right
            //here, reading _id off undefined, which left the page spinning forever
            const match = res?.data?.data?.find(
                (ct) => ct.name.split(" ").join("-").toLowerCase() === catalogName
            );

            if(!match){
                setNotFound(true);
                return;
            }

            setCategoryId(match._id);
        }
        getCategories();
    },[catalogName]);

    useEffect(() => {
        const getCategoryDetails = async() => {
            try{
                const res = await getCatalogPageData(categoryId);
                console.log("PRinting res: ", res);
                setCatalogPageData(res);
            }
            catch(error) {
                console.log(error)
            }
        }
        if(categoryId) {
            getCategoryDetails();
        }
        
    },[categoryId]);


    //Only a category that genuinely does not exist is an error...one that simply
    //has no courses yet is handled further down with an empty state
    if (notFound) {
        return <Error />
    }

    if (loading || !catalogPageData) {
        return (
          <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
            <div className="spinner"></div>
          </div>
        )
    }

    if (!catalogPageData.success) {
        return <Error />
    }

    const selectedCourses = catalogPageData?.data?.selectedCategory?.courses ?? []
    const otherCategory = catalogPageData?.data?.differentCategory
    const mostSelling = catalogPageData?.data?.mostSellingCourses ?? []

  return (
    <>
          {/* Hero Section */}
          <div className=" box-content bg-richblack-800 px-4">
            <div className="mx-auto flex min-h-[260px] max-w-maxContentTab flex-col justify-center gap-4 lg:max-w-maxContent ">
              <p className="text-sm text-richblack-300">
                {`Home / Catalog / `}
                <span className="text-yellow-25">
                  {catalogPageData?.data?.selectedCategory?.name}
                </span>
              </p>
              <p className="text-3xl text-richblack-5">
                {catalogPageData?.data?.selectedCategory?.name}
              </p>
              <p className="max-w-[870px] text-richblack-200">
                {catalogPageData?.data?.selectedCategory?.description}
              </p>
            </div>
          </div>
    
          {/* Section 1 */}
          <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
            {selectedCourses.length === 0 ? (
              //A brand new category has nothing in it until an instructor publishes
              //something, which is normal rather than an error
              <div className="flex flex-col items-center gap-3 rounded-lg border border-richblack-700 bg-richblack-800 py-16 px-6 text-center">
                <p className="text-2xl font-semibold text-richblack-5">
                  No courses here yet
                </p>
                <p className="max-w-[520px] text-richblack-300">
                  Nothing has been published under{" "}
                  {catalogPageData?.data?.selectedCategory?.name} so far. Once an
                  instructor adds a course to this category it will show up here.
                </p>
                <Link
                  to="/courses"
                  className="mt-2 rounded-md bg-yellow-50 px-6 py-2 font-semibold text-richblack-900"
                >
                  Browse all courses
                </Link>
              </div>
            ) : (
              <>
                <div className="section_heading text-white">Courses to get you started</div>
                <div className="my-4 flex border-b border-b-richblack-600 text-sm">
                  <p
                    className={`px-4 py-2 ${
                      active === 1
                        ? "border-b border-b-yellow-25 text-yellow-25"
                        : "text-richblack-50"
                    } cursor-pointer`}
                    onClick={() => setActive(1)}
                  >
                    Most Populer
                  </p>
                  <p
                    className={`px-4 py-2 ${
                      active === 2
                        ? "border-b border-b-yellow-25 text-yellow-25"
                        : "text-richblack-50"
                    } cursor-pointer`}
                    onClick={() => setActive(2)}
                  >
                    New
                  </p>
                </div>
                <div>
                  <CourseSlider Courses={selectedCourses} />
                </div>
              </>
            )}
          </div>

          {/* Section 2...only when there is another category with something in it.
          differentCategory is null when this is the only category that exists */}
          {otherCategory?.courses?.length > 0 && (
            <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
              <div className="section_heading text-white">
                Top courses in {otherCategory?.name}
              </div>
              <div className="py-8">
                <CourseSlider Courses={otherCategory.courses} />
              </div>
            </div>
          )}

          {/* Section 3 */}
          {mostSelling.length > 0 && (
            <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
              <div className="section_heading text-white">Frequently Bought</div>
              <div className="py-8">
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                  {mostSelling.slice(0, 4).map((course, i) => (
                    <CourseCard course={course} key={i} Height={"h-[400px]"} />
                  ))}
                </div>
              </div>
            </div>
          )}
          
          <Footer />
        </>
  )
}

export default Catalog
